import StoreModuleService from '../StoreModuleService';
import { MODULE_NAME } from './const';
import state from './state';
import { SET_NATIVE_ELEMENT_DATA } from './mutations';
import api from '@/api';
import { isNullOrUndefined } from '@/utils/helpers';

const buildNativeElementActionObject = (action) => StoreModuleService.buildActionObject(MODULE_NAME, action);

// actions declarations
export const getNativeElementData = buildNativeElementActionObject('getNativeElementData');
export const setNativeElementData = buildNativeElementActionObject('setNativeElementData');
export const updateTestParamsMap = buildNativeElementActionObject('updateTestParamsMap');
export const updateNativeElement = buildNativeElementActionObject('updateNativeElement');

const actions = {
	...StoreModuleService.createDefaultActions(),
	async [getNativeElementData.action]({ dispatch }, payload) {
		const { id, forceGet } = payload;
		const dataIsMissing = isNullOrUndefined(state.data[id]);
		const needToGet = dataIsMissing || forceGet;
		if (needToGet) {
			const ret = await api.getNativeElement(id);
			dispatch(setNativeElementData.action, { data: ret, forceGet });
		}
	},
	[setNativeElementData.action]({ commit }, payload) {
		const { data: nativeElementData } = payload;
		commit(SET_NATIVE_ELEMENT_DATA, { key: nativeElementData.id, value: nativeElementData });
	},
	async [updateTestParamsMap.action](context, payload) {
		const { elementId, paramsMap, paramsMapLabels } = payload;
		await api.updateNativeElementTestParamsMap(elementId, paramsMap, paramsMapLabels);
	},
	async [updateNativeElement.action]({ dispatch }, payload) {
		const { id, data } = payload;
		const ret = await api.updateNativeElement(id, data);
		dispatch(setNativeElementData.action, { data: ret });
	},
};

export default actions;
